import Bugsnag from '@bugsnag/js';
import getCsrfToken from '@99designs/common/utils/app/getCsrfToken';

const fetchPreAuthorisation = (search: string) => {
    const csrfToken = getCsrfToken();
    if (!csrfToken) {
        return Promise.resolve({});
    }

    const params = new URLSearchParams(search);
    params.append('csrf_token', csrfToken);
    const paramString = params.toString();

    return fetch(`/accounts/xhr/pre-auth?${paramString.toString()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    })
        .then((response) => response.json())
        .catch((e) => {
            Bugsnag.notify(e, (event) => {
                event.context = 'pre authorisation';
            });
        });
};

export default fetchPreAuthorisation;
